import type { HTMLAttributes } from "react";
import { cx } from "@/utils/cx";

const sizes = {
	sm: {
		wh: 8,
		c: 4,
		r: 2.5,
	},
	md: {
		wh: 10,
		c: 5,
		r: 4,
	},
	lg: {
		wh: 12,
		c: 6,
		r: 4.5,
	},
	xlg: {
		wh: 14,
		c: 7,
		r: 5.5,
	},
};

export type DotSize = keyof typeof sizes;

/**
 * Small circular status / badge accent mark.
 *
 * @param size - Visual size matching Figma `_Dot` (sm–xlg).
 * @param outline - When true, draws a light ring around the fill (Figma Outline=True).
 */
export const Dot = ({
	size = "md",
	outline = false,
	className,
	...props
}: HTMLAttributes<HTMLOrSVGElement> & {
	size?: DotSize;
	outline?: boolean;
}) => {
	return (
		<svg
			width={sizes[size].wh}
			height={sizes[size].wh}
			viewBox={`0 0 ${sizes[size].wh} ${sizes[size].wh}`}
			fill="none"
			{...props}
			aria-label="Dot Icon"
			className={cx(
				outline && "rounded-full ring-1 ring-bg-primary",
				className,
			)}
		>
			<title>Dot Icon</title>
			<circle
				cx={sizes[size].c}
				cy={sizes[size].c}
				r={sizes[size].r}
				fill="currentColor"
				stroke="currentColor"
			/>
		</svg>
	);
};
